var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 33C8.15789 33 1 25.8421 1 17C1 8.15789 8.15789 1 17 1C25.8421 1 33 8.15789 33 17C33 25.8421 25.8421 33 17 33Z",
    stroke: "#619428",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9576 13.4631H9.67334V24.1579H12.9576V13.4631Z",
    fill: "#619428"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3577 12.0316C12.4525 12.0316 13.2946 11.1053 13.2946 10.0947C13.2946 9.08421 12.4525 8.1579 11.3577 8.1579C10.263 8.1579 9.4209 9.08421 9.4209 10.0947C9.4209 11.1053 10.263 12.0316 11.3577 12.0316Z",
    fill: "#619428"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3475 18.5158C18.3475 17 19.0211 16.0737 20.3685 16.0737C21.5475 16.0737 22.1369 16.9158 22.1369 18.5158C22.1369 20.0316 22.1369 24.1579 22.1369 24.1579H25.4211C25.4211 24.1579 25.4211 20.2842 25.4211 17.3369C25.4211 14.4737 23.8211 13.0421 21.5475 13.0421C19.2738 13.0421 18.3475 14.8105 18.3475 14.8105V13.379H15.1475V24.0737H18.3475C18.3475 24.1579 18.3475 20.2 18.3475 18.5158Z",
    fill: "#619428"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinOrange);
export default __webpack_public_path__ + "static/media/linkedin_orange.14b8e743fefca3694622e65a3b8012f1.svg";
export { ForwardRef as ReactComponent };